export default __webpack_public_path__ + "static/media/流浪救助勋章@2x.6f60519f.png";